import styled from "styled-components";
import Hint from "@assets/svg/Hint.svg?react";
import CheckBox1 from "@assets/svg/CheckBox1.svg?react";

interface ResponsiveProps {
  $isPhone?: boolean;
  $lang?: string;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const ModalWrapper = styled.span<ResponsiveProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ $isPhone }) => ($isPhone ? "90vw" : "1000px")};
  max-width: 100vw;
  outline: none;
  border-top-left-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "16px")};
  border-bottom-left-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "16px")};
  background: #ffffff;
  height: fit-content;
  max-height: ${({ $isPhone }) => ($isPhone ? "90vh" : "auto")};
  overflow-y: ${({ $isPhone }) => ($isPhone ? "auto" : "visible")};
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const HintWrapper = styled(Hint)<ResponsiveProps>`
  position: absolute;
  top: ${({ $isPhone }) => ($isPhone ? "80px" : "110px")};
  width: ${({ $isPhone }) => ($isPhone ? "300px" : "370px")};
  height: ${({ $isPhone }) => ($isPhone ? "280px" : "320px")};
  transform: ${({ $isPhone }) =>
    $isPhone ? "translate(-10%, 0)" : "translate(-145%, -30%)"};
  background: white;
  border-radius: 14px;
  z-index: 1;
`;
export const CloseButtonWrapper = styled.span<ResponsiveProps>`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: end;
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "0")};
`;

export const CloseMenuIcon = styled.div<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "16px" : "14px")};
  height: ${({ $isPhone }) => ($isPhone ? "16px" : "14px")};
  fill: black;
  margin: ${({ $isPhone }) => ($isPhone ? "8px" : "25px")};
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const CardContainer = styled.div<ResponsiveProps>`
  margin-top: 81px;
`;

export const ImageWrapper = styled.div<ResponsiveProps>`
  margin-top: ${({ $isPhone }) => ($isPhone ? "24px" : "42px")};
  display: flex;
  justify-content: center;
  background: #fafafb;
  padding-top: 50px;
  width: ${({ $isPhone }) => ($isPhone ? "100%" : "565.18px")};
  max-width: 100%;
  height: ${({ $isPhone }) => ($isPhone ? "auto" : "300px")};
  border-radius: 14.29px;
  box-sizing: border-box;
`;

export const ContentBox = styled.span<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isPhone }) => ($isPhone ? "center" : "start")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "55px")};
  gap: 0;
  background: white;
  position: relative;
  text-align: ${({ $isPhone }) => ($isPhone ? "center" : "start")};
  margin-bottom: 32px;
  box-sizing: border-box;
`;

export const Title = styled.span<ResponsiveProps>`
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "18px" : "20px")};
  color: #0f172a;
`;

export const Description = styled.span<ResponsiveProps>`
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: #8e98a1;
`;

export const SliderContainer = styled.span<ResponsiveProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "34px")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "0")};
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  background: #ffffff;
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "10px")};
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "24px")};
  border-bottom-right-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "24px")};
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  border-top: 1px solid #0000001a;
  flex-direction: ${({ $isPhone }) => ($isPhone ? "column" : "row")};
  box-sizing: border-box;
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width, $isPhone }) => ($isPhone ? "100%" : $width)};
  height: ${({ $isPhone }) => ($isPhone ? "44px" : "49px")};
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
  }

  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: ${({ $isPhone }) => ($isPhone ? "8px" : "0")};
  }
`;

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 97px;
`;

export const RowWrapper = styled.div<ResponsiveProps>`
  display: flex;
  flex-direction: ${({ $isPhone }) => ($isPhone ? "column" : "row")};
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-inline: 55px;
  gap: 8px;
  box-sizing: border-box;
`;

export const PropertyBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: start;
  background: white;
  text-align: center;
  height: 64px;
  font-weight: 700;
  font-size: 14px;
  color: #331860;
  border: 1px solid #e9e9e7;
  border-radius: 16px;
  box-sizing: border-box;
  width: 100%;
  padding-inline: 24px;
  gap: 10px;
`;

export const InputSection = styled.section`
  position: relative;
  flex: 1;
`;

export const InputBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e9e9e7;
  border-radius: 16px;
  padding: 0 20px;
  height: 64px;
  gap: 12px;
  position: relative;
  background-color: #f8fafc;
  width: 100%;
  box-sizing: border-box;
`;

export const InputColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Label = styled.span`
  font-weight: 400;
  color: #475467;
  font-size: 16px;
  min-width: max-content;
`;

export const StyledInput = styled.input`
  flex: 1;
  background: #f8fafc;
  color: #a3a3a3;
  font-weight: 400;
  font-size: 14px;
  border: none;
  outline: none;
  padding-inline: 5px;
  padding: 6px 10px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  &::placeholder {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const HintLink = styled.a`
  position: absolute;
  color: #5b3fff;
  font-size: 16px;
  text-decoration: none;
  margin-top: 4px;
  text-align: right;
  display: block;
`;

export const ChannelHeaderRow = styled.div<ResponsiveProps>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-inline: 55px;
  gap: 8px;
  text-align: center;
  height: 38px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  box-sizing: border-box;
`;

export const ChannelBox = styled.span<ResponsiveProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  text-align: center;
  padding-block: 5px;
  flex: 1;
`;

export const ChannelLogoIcon = styled.span`
  margin-inline: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledCheckBox = styled(CheckBox1)<{
  $hasError?: boolean;
  $hasSuccess?: boolean;
}>`
  fill: ${({ $hasError, $hasSuccess }) =>
    $hasSuccess ? "#22c55e" : $hasError ? "#ef4444" : "#475467"};
  opacity: ${({ $hasError, $hasSuccess }) =>
    $hasError || $hasSuccess ? 1 : 0.56};
  filter: ${({ $hasSuccess, $hasError }) =>
    $hasSuccess
      ? "drop-shadow(0 0 2px rgba(34, 197, 94, 0.3))"
      : $hasError
        ? "drop-shadow(0 0 2px rgba(239, 68, 68, 0.3))"
        : "none"};
`;
